"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var channel_1 = require("iris/dist/helpers/ibe/channel");
var State = /** @class */ (function () {
    // create everything with initial defaults
    function State() {
        // api call status: cache last url fragment
        this.loading = '';
        // channel to use fpr IBE requests via iris
        this.channel = channel_1.IBEChannel;
        this.list = [];
        this.selected = '';
        this.priceDiffer = [];
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map